export type RegionCodes = "AT-02" | "AT-03" | "AT-04" | "AT-05" | "AT-06" | "AT-08" | "DE-BY";

export const regionCodes: readonly RegionCodes[] = Object.freeze([
  "AT-02",
  "AT-03",
  "AT-04",
  "AT-05",
  "AT-06",
  "AT-08",
  "DE-BY"
]);

export const regionsRegex = /^(AT-02|AT-03|AT-04|AT-05|AT-06|AT-08|DE-BY)/;
export const scopedRegionsRegex = province => province ? new RegExp(`^${province}`) : regionsRegex;
